<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      persistent
      scrollable
      width="600">
      <v-card height="600">
        <v-card-title>
          ชื่อ : {{ filterName }}
        </v-card-title>
        <v-card-subtitle class="pt-2">
          เวลา : {{ $dayjs(filterDate).tz('Asia/Bangkok').format('YYYY-MM-DD || HH:mm') }}
        </v-card-subtitle>
        <v-card-text>
          <v-treeview
            :items="filterDetail"
            open-all
            hoverable />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="closeModal()">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import FiltersProvider from '@/resources/FiltersProvider'
import schemas from '@/utils/schema.json'

const filtersService = new FiltersProvider()
export default {
  props: {
    display: {
      type: Boolean,
      default: false
    },
    filterId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      show: false,
      loading: false,
      filterName: '',
      filterDate: null,
      filterDetail: [
        {
          name: 'เครื่องหมายตรรกศาสตร์ :',
          children: []
        },
        {
          name: 'ตัวกรอง :',
          children: []
        }
      ]
    }
  },
  watch: {
    display: {
      handler (val) {
        this.show = val
      }
    },
    filterId: {
      handler () {
        this.initOptions()
      }
    }
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    closeModal () {
      this.show = false
      this.$emit('close')
    },
    prepareOptions (value) {
      const result = []
      Object.keys(value).forEach((key) => {
        if (Object.keys(value[key]).length > 1 && typeof value[key] !== 'string' && !Array.isArray(value[key])) {
          result.push({
            name: `${key}`,
            children: this.prepareOptions(value[key])
          })
        } else if (key !== 'source') {
          result.push({ name: `${key}: ${value[key]}` })
        } else if (key === 'source') {
          const schema = schemas.source
          const temp = []
          value[key].forEach((element) => {
            const index = schema.options.findIndex((field) => field.value === element)
            if (index !== -1) {
              temp.push(schema.options[index].label)
            }
          })

          result.push({ name: `${key}: ${temp}` })
        }
    })

      return result
    },
    async initOptions () {
      this.loading = true
      try {
        const { data } = await filtersService.getFilterByID(this.filterId)
        this.filterDetail = [
          {
            name: 'เครื่องหมายตรรกศาสตร์',
            children: []
          },
          {
            name: 'ตัวกรอง',
            children: []
          }
        ]
        this.filterName = data.name
        this.filterDate = data.createdAt
        let operatorIndex = 1
        data.operators.forEach((operator) => {
          this.filterDetail[0].children.push({
            name: `(${operatorIndex}) ${operator.toString()}`
          })
          operatorIndex++
        })
        const optionsTemp = []
        let optionIndex = 1
        data.options.forEach((option) => {
          optionsTemp.push({
            name: `ฟอร์มที่ (${optionIndex})`,
            children: this.prepareOptions(option)
          })

          optionIndex++
        })

        this.filterDetail[1].children = optionsTemp
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: `เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง (code ${e.code})`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
